
import { Canvas, Line, Text, Group } from "fabric";
import { pixelsToMillimeters } from "@/utils/measurement-utils";
import { MeasurementService } from "@/services/measurement-service";
import { calculateLabelOffset } from "./measurement-label-utils";
import { createMeasuredGroup } from "./group-utils";

export const updateLineMeasurements = (line: Line, label: Text | Group, canvas: Canvas) => {
  if (!line) return;

  const parent = line.group;
  const parentScaleX = parent ? (parent.scaleX || 1) : 1;
  const parentScaleY = parent ? (parent.scaleY || 1) : 1;

  const dx = (line.x2! - line.x1!) * parentScaleX;
  const dy = (line.y2! - line.y1!) * parentScaleY;
  const length = Math.sqrt(dx * dx + dy * dy);
  const lengthMm = Math.round(pixelsToMillimeters(length, canvas));
  
  // Update the text content with consistent styling
  MeasurementService.updateMeasurementText(label, `${lengthMm}mm`);

  // Update label position based on new line orientation if needed
  if (parent && label instanceof Group) {
    const angle = Math.atan2(dy, dx) * (180 / Math.PI);
    label.set({ angle: angle });
  }

  canvas.renderAll();
};

export const createMeasuredLine = (canvas: Canvas, points: [number, number, number, number], props: any) => {
  const line = new Line(points, props);
  
  const dx = points[2] - points[0];
  const dy = points[3] - points[1];
  const length = Math.sqrt(dx * dx + dy * dy);
  const lengthMm = Math.round(pixelsToMillimeters(length, canvas));
  
  // Get the midpoint of the line for label positioning
  const midX = (points[0] + points[2]) / 2;
  const midY = (points[1] + points[3]) / 2;
  
  // Calculate the angle of the line
  const angle = Math.atan2(dy, dx) * (180 / Math.PI);
  
  // Get current zoom for proper scaling
  const zoom = canvas.getZoom();
  
  // Create measurement label
  const label = MeasurementService.createMeasurementLabel(
    `${lengthMm}mm`,
    props.left + midX,
    props.top + midY,
    angle,
    true,
    zoom
  );

  // Create a group with the line and its measurement
  const group = MeasurementService.createMeasurementGroup(
    line, 
    [label], 
    canvas, 
    'line'
  );
  
  return group;
};
